// extracted by mini-css-extract-plugin
module.exports = {"starRating":"StarRating_starRating__1BJyU","noRate":"StarRating_noRate__3Zy86","focusRing":"StarRating_focusRing__1ruaR"};